import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory, Router } from 'react-router';
import { Provider, connect } from 'react-redux';
import { setAppRefreshedFlag } from '../store/app';
import loadWhatFixScript from '../common/scripts/whatFix';

export class AppContainer extends Component {
  componentDidMount() {
    this.props.setAppRefreshedFlag(true);
    loadWhatFixScript();
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    const { routes, store } = this.props;
    return (
      <Provider store={store}>
        <Router history={browserHistory}>{routes}</Router>
      </Provider>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    contextId: state.app.contextId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setAppRefreshedFlag: (flag) => dispatch(setAppRefreshedFlag(flag)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer);

AppContainer.propTypes = {
  routes: PropTypes.object.isRequired,
  store: PropTypes.object.isRequired,
  setAppRefreshedFlag: PropTypes.func,
  contextId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};



// WEBPACK FOOTER //
// ./src/containers/AppContainer.js